import http from '@/store/http';

// 部门树（按 parentId 递归构建，seqno 升序）
export const getDepartmentTree = (data?: { departmentName?: string; status?: number }) => {
  return http.request('/operate/department/tree', 'GET', data);
};

// 部门分页（平铺；后端内存分页）
export const getDepartmentPage = (data?: {
  pageNo?: number;
  pageSize?: number;
  departmentName?: string;
  status?: number;
}) => {
  return http.request('/operate/department/page', 'GET', data);
};

// 部门详情
export const getDepartmentDetail = (deptId: number | string) => {
  return http.request(`/operate/department/${deptId}`, 'GET');
};

// 部门下的推广人（规划师）列表，平铺不分页
export const listDepartmentPromoters = (deptId: number | string) => {
  return http.request(`/operate/department/${deptId}/promoters`, 'GET');
};

// 部门对应顶级组织（parent_id=0）及其所有子孙下的推广人
export const listRootPromoters = (deptId: number | string) => {
  return http.request(`/operate/department/${deptId}/root-promoters`, 'GET');
};

// 批量移动推广人到目标部门（仅更新 user_department.department_id）
export const movePromoters = (data: {
  toDeptId: number | string;
  promoterIds: (number | string)[];
}) => {
  return http.request('/operate/department/promoters/move', 'POST_JSON', data);
};

// 设为/取消小组管理员（type: 1=设为管理员 / 0=取消管理员）
export const setDepartmentManager = (data: { userId: number | string; type: 0 | 1 }) => {
  return http.request('/operate/department/manager', 'POST_JSON', data);
};

// 新增 / 编辑（departmentId 空 = 新增，非空 = 编辑）
export const saveOrUpdateDepartment = (data: {
  departmentId?: number;
  departmentName: string;
  parentId: number;
  seqno?: number;
  status?: number;
}) => {
  return http.request('/operate/department', 'POST_JSON', data);
};

// 删除
export const deleteDepartment = (deptId: number | string) => {
  return http.request(`/operate/department/${deptId}`, 'DELETE');
};

// 可选部门列表（下拉用，Redis 缓存 5 分钟；用于数据筛选默认回显）
export const getDepartmentSelectList = () => {
  return http.request('/operate/department/list/select', 'GET');
};

// 数据筛选 — 提交选中的部门 ID 列表（一级一个，平铺为数组）
export const submitDepartmentFilter = (departmentIds: (number | string)[]) => {
  return http.request('/operate/department/data-filter', 'POST_JSON', { departmentIds });
};
